import * as styleConstants from "@affinity/constants/StyleConstants";
import * as styleHelpers from "@affinity/constants/StyleHelpers";
import Link from "@insite/mobius/Link";
import { TypographyProps } from "@insite/mobius/Typography";
import styled, { css } from "styled-components";

export const myAccountOrderEdgeToEdge = css`
position:relative;
background-color: ${styleConstants.colours.white};
padding:0 20px;
margin: 0 auto 50px;
3px 6px 40px 0px rgba(0, 0, 0, 0.10);
@media (min-width: ${styleHelpers.rem(1280)}){
    padding: ${styleHelpers.rem(30)};
    border-radius: 10px;
}
&::before{
    position:absolute;
    top:0;
    bottom:-50px;
    left:0;
    right:0;
    margin: 0 calc((100% - 100vw) / 2);
    z-index: -1;
    background-color: ${styleConstants.colours.lightBlue};
    content: "";
}
`;

export const myAccountOrderGridItemCss = css`
    padding: ${styleHelpers.rem(10)};
    width: 100%;
`
export const MyAccountOrderCardComponent = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${styleConstants.colours.lightBlue20};
    padding: ${styleHelpers.rem(20)};
    border-radius: ${styleHelpers.rem(10)};
    @media (min-width: ${styleHelpers.rem(1280)}){
        padding: ${styleHelpers.rem(30)};
	}
`;

export const myAccountOrderHeaderProps: TypographyProps = {
    weight: 700,
    size: styleHelpers.rem(18),
    lineHeight: 1.44,
    color: styleConstants.colours.black,
    css: css`
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        font-family: ${styleConstants.headerFont};
        color: ${styleConstants.colours.black};
        @media (min-width: ${styleHelpers.rem(1280)}){
            font-size: ${styleHelpers.rem(20)};
            line-height: 1.40;
	    }
    `
}

export const myAccountOrderCardHeaderProps: TypographyProps = {
    weight: 600,
    css: css`
        display: block;
        font-size: ${styleHelpers.rem(20)};
        line-height: 1.3;
        padding: 0 0 ${styleHelpers.rem(15)};
        color: ${styleConstants.colours.black};
        @media (min-width: ${styleHelpers.rem(1280)}){
            font-size: ${styleHelpers.rem(20)};
            line-height: 1.40;
            padding: 0 0 ${styleHelpers.rem(20)};

        }
    `
}
export const myAccountOrderCardInfoProps: TypographyProps = {
    weight: 300,
    css: css`
        display: block;
        font-size: ${styleHelpers.rem(15)};
        color: ${styleConstants.colours.black};
        line-height: 1.33;
        padding: 0 0 ${styleHelpers.rem(10)};
        @media (min-width: ${styleHelpers.rem(1280)}){
            font-size: ${styleHelpers.rem(16)};
            line-height: 1.50;
	    }
    `
}

export const StyledLink = styled(Link)`
    &&& span {
        transition: none;
    }
`;